export default {
  "content": "<path d=\"M13 17.586l5.793-5.792 1.414 1.413-7.5 7.5a1 1 0 01-1.414 0l-7.5-7.5 1.414-1.414L11 17.587V4h2v13.586z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};